module.exports = __webpack_public_path__ + "img/shopee.59236927.svg";